import { useTranslation } from "react-i18next";
import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Col, message, Pagination, Row, Spin, Typography } from 'antd'
import { PaginationProps } from 'antd/lib'
import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc"
import { isEmpty } from 'lodash'
import { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import EmptyComponent from '../../../components/empty'
import FormInput from '../../../components/form-input/FormInput'
import SafeLink from '../../../components/link/SafeLink'
import PageHeader from '../../../components/page-header/PageHeader'
import { routesConfig } from '../../../config/routes'
import useKeyword from '../../../hooks/useKeyword'
import { addTestSchedule, editTestSchedule, getTestScheduleList } from '../../../service/test-schedule'
import { TestScheduleType } from '../../../types/testSchedule'
import { itemRenderPaging, renderTestScheduleStatus } from '../../../utils/functionUltils'
import ConfigScoreModal from './components/ConfigScoreModal'
import FormFilter from './components/FormFilter'
import TestScheduleModal from './components/TestScheduleModal'
import "./style.scss"
dayjs.extend(utc);
const { Title } = Typography;
interface UnitInfo {
	courseName: string,
	unitName: string,
}

interface FilterDataType {
	stars?: number[];
	class?: any[];
	status?: number;
	timeCreated?: any;
}
type Props = {}
const TestScheduleList = (props: Props) => {
  const { t } = useTranslation();
	const imgPath = "/images/";
	const unitId = useKeyword("unitId");

	const { courseId } = useParams()
	const [testScheduleList, setTestScheduleList] = useState<TestScheduleType[]>([])
	const [isAddTestSchedule, setIsAddTestSchedule] = useState<boolean>(false)
	const [modalMode, setModalMode] = useState<"create" | "view" | "edit">("create");
	const [selectedSchedule, setSelectedSchedule] = useState<any>(null);
	const [unitInfo, setUnitInfo] = useState<UnitInfo>({
		courseName: "",
		unitName: "",
	});
	const [reload, setReload] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const [showFilter, setShowFilter] = useState<boolean>(false);
	const [pageSize, setPageSize] = useState<number>(10)
	const [pageNumber, setPageNumber] = useState<number>(1)
	const [totalPage, setTotalPage] = useState<number>(0)
	const [searchValue, setSearchValue] = useState<string>("")
	const [filterData, setFilterData] = useState<FilterDataType>({
		class: [],
		status: undefined,
		timeCreated: undefined,
	});
	const [isConfigScore, setIsConfigScore] = useState<boolean>(false);

	const listBreadcrumb = [
		{
			title: t("Xây dựng khoá học", "Xây dựng khoá học"),
		},
		{
			title: (
				<>
					<SafeLink to={`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}`}>
						<span>{t("Xây dựng Nội dung", "Xây dựng Nội dung")}</span>
					</SafeLink>
				</>
			),
		},
		{
			title:
				<SafeLink to={`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/${courseId}`}>
					<span>{unitInfo?.courseName}</span>
				</SafeLink>
		},
		{
			title: unitInfo?.unitName,
		},
	];

	const handleAddTestSchedule = async (values: any) => {
		const { name, location, date, timeRange, applyTo } = values;
		const [startTime, endTime] = timeRange.map((t: string) => dayjs(t));

		const mergeDateTime = (baseDate: string, timeVal: dayjs.Dayjs) =>
			dayjs(baseDate)
				.hour(timeVal.hour())
				.minute(timeVal.minute())
				.second(timeVal.second())
				.millisecond(timeVal.millisecond())
				.toISOString();

		const payload = {
			unitId: Number(unitId),
			name,
			location,
			enrollClassIds: applyTo,
			timeStart: mergeDateTime(date, startTime),
			timeEnd: mergeDateTime(date, endTime),
		};

		try {
			modalMode === "create"
				? await addTestSchedule(payload)
				: await editTestSchedule(selectedSchedule?.id, payload);
			message.success(`${modalMode === "create" ? "Thêm mới" : "Sửa"} lịch thành công`);
			setReload(!reload);
			setIsAddTestSchedule(false);
		} catch (error) {
			console.error("Lỗi khi thêm/sửa lịch kiểm tra", error);
		}
	};



	const handleOpenFilter = () => {
		setShowFilter(!showFilter);
	};

	const handleCloseFilter = () => {
		setShowFilter(false);
	};



	const onChange: PaginationProps['onChange'] = (pageNumber) => {
		setPageNumber(pageNumber);
	};
	const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, size) => {
		setPageSize(size);
		setPageNumber(1);
	};

	const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setSearchValue(value);
	};
	const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
		if (e.key === "Enter") {
			setPageNumber(1);
			fetchTestScheduleData();
		}
	};

	const handleSubmitSearch = () => {
		setPageNumber(1);
		fetchTestScheduleData();

	}
	const fetchTestScheduleData = async () => {
		setIsLoading(true);
		try {
			const payload = {
				page: pageNumber,
				size: pageSize,
				enrollClassIds: filterData?.class || [],
				status: filterData?.status,
				unitId: unitId,
				keyword: searchValue,
				timeStart: !isEmpty(filterData?.timeCreated)
					? dayjs(filterData?.timeCreated?.[0])
						.toISOString()
					: undefined,
				timeEnd: !isEmpty(filterData?.timeCreated)
					? dayjs(filterData?.timeCreated?.[1])
						.toISOString()
					: undefined,
			}
			const res = await getTestScheduleList(payload)
			setTestScheduleList(res?.data.data.data)
			setUnitInfo({
				courseName: res.data.data.course,
				unitName: res.data.data.unit,
			})
			setTotalPage(res?.data.data.total)
		} catch (error) {

		}
		finally {
			setIsLoading(false);
		}
	}
	useEffect(() => {
		fetchTestScheduleData()
	}, [pageNumber, pageSize, filterData, reload]);
	return (
		<div className='test-schedule'>
			<PageHeader
				title={unitInfo?.unitName}
				subTitle=''
				breadcrumb={true}
				listBreadcrumb={listBreadcrumb}
				arrowLeft={imgPath + 'arrowLeft.svg'}
				positionItem='column'
				headerGroupButton={true}
				childrenGroupButton={
					<div className='button-container'>
						<Button className="filter-button" onClick={handleOpenFilter}>
							<Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
							<DownOutlined />
						</Button>
						<FormInput
							placeholder={t("Nhập tên lịch kiểm tra", "Nhập tên lịch kiểm tra")}
							value={searchValue}
							onChange={handleChangeInput}
							onKeyPress={handleSearch}
							afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
						/>
						<Button onClick={() => setIsConfigScore(true)}>
							{t("Cài đặt", "Cài đặt")}
						</Button>
						<Button
							type="primary"
							onClick={() => { setModalMode("create"); setIsAddTestSchedule(true); }}
						>
							{t("Thêm mới lịch", "Thêm mới lịch")}
						</Button>
					</div>
				}
			/>
			{showFilter ? (
				<div className="form-filter">
					<FormFilter
						handleCloseFilter={handleCloseFilter}
						showFilter={showFilter}
						setFilterData={setFilterData}
					/>
				</div>

			) : null}

			{isLoading ? <div className="test-schedule-loading">
				<Spin />
			</div> :
				<div className="test-schedule-content">
					<div className="content">
						{
							testScheduleList?.length > 0 ? <Row gutter={[16, 16]} className="test-schedule-row">
								{testScheduleList?.map((it: TestScheduleType) => (
									<Col
										key={it?.id}
										className="gutter-row"
										xs={24}
										sm={12}
										md={8}
										lg={6}
										xl={6}
										xxl={6}
										onClick={() => {
											setModalMode("view");
											setSelectedSchedule(it);
											setIsAddTestSchedule(true);
										}}
									>
										<div className="card-item">
											<Title level={5}>{it?.name}</Title>
											<div>{t("Trạng thái:", "Trạng thái:")} {renderTestScheduleStatus(it?.status)}</div>
											<div>{t("Thời gian tổ chức:", "Thời gian tổ chức:")} {dayjs(it?.timeStart).format("DD/MM/YYYY")} {dayjs(it?.timeStart).format("HH:mm")} - {dayjs(it?.timeEnd).format("HH:mm")}</div>
											<div>{t("Địa điểm tổ chức:", "Địa điểm tổ chức:")} {it?.location}</div>
											<div className="class">
												{t("Lớp:", "Lớp:")}
												{it?.enrollClassData.slice(0, 4).map((cl: any, index: number) => (
													<span key={cl?.id} className="class-item">
														{cl?.name}
													</span>
												))}
												{it?.enrollClassData.length > 4 && (
													<span className="class-item">+{it?.enrollClassData.length - 4}</span>
												)}
											</div>
										</div>
									</Col>
								))}
							</Row> : <div className="empty-schedule">
								<EmptyComponent description={t("Chưa có lịch thi cho học liệu", "Chưa có lịch thi cho học liệu")} />
							</div>
						}
					</div>

					<Pagination
						total={totalPage}
						showSizeChanger
						pageSize={pageSize}
						current={pageNumber}
						className="pagination-table"
						onChange={onChange}
						onShowSizeChange={onShowSizeChange}
						itemRender={itemRenderPaging}
						locale={{
							items_per_page: "/ trang",
							jump_to: t("Đi đến trang", "Đi đến trang"),
							page: "",
						}}
						showQuickJumper
						showTotal={(total) => `${t("Tổng số", "Tổng số")} ${total} ${t("bản ghi", "bản ghi")}`}
					/>
				</div>
			}
			<TestScheduleModal
				open={isAddTestSchedule}
				mode={modalMode}
				onCancel={() => setIsAddTestSchedule(false)}
				onSave={(values) => {
					handleAddTestSchedule(values)
				}}
				onEdit={() => setModalMode("edit")}
				scheduleData={selectedSchedule}
			/>

			<ConfigScoreModal open={isConfigScore}
				handleCancel={() => setIsConfigScore(false)}
			/>
		</div>
	)
}

export default TestScheduleList